// src/components/ProgressBar.js
import React from 'react';

const ProgressBar = ({ completedTasks, totalTasks }) => {
  const progress = (completedTasks / totalTasks) * 100;

  return (
    <div className="progress-bar">
      <div className="progress-bar__completed" style={{ width: `${progress}%` }}>
        {completedTasks} / {totalTasks}
      </div>
    </div>
  );
};

export default ProgressBar;
